var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  '_top': _vm.top,
  '_bottom': _vm.bottom,
},on:{"scroll":_vm.onCheck}},[_vm._t("default",null,{"top":_vm.top,"bottom":_vm.bottom})],2)}
var staticRenderFns = []

export { render, staticRenderFns }